var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.$store.getters.curPageDefine)?_c('div',[(this.$store.getters.curPageGroupDefine.pageStyle == '1')?_c('PortalLayout'):_vm._e(),_vm._v(" "),(this.$store.getters.curPageGroupDefine.pageStyle == '2')?_c('ConsoleLayout'):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02b9d388","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/MainPage.vue
// module id = null
// module chunks = 